import React, { useState, useEffect } from "react";
import { Menu, X, Terminal } from "lucide-react";
import { useLocation } from "react-router-dom";

const Layout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { name: "About", href: "#home" },
    { name: "Education", href: "#education" },
    { name: "Tech", href: "#tech" },
    { name: "Experience", href: "#experience" },
    { name: "Projects", href: "#project" },
    { name: "Honors", href: "#achievement" },
    { name: "Contact", href: "#contact" },
  ];

  const isActive = (path) => location.hash === path;

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${scrolled ? "bg-[#0b0f19]/80 backdrop-blur-2xl border-b border-white/10 py-2" : "bg-transparent py-4"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <a
            href="#home"
            className="group flex items-center gap-2 text-2xl font-black text-white tracking-tighter transition-all hover:scale-105"
          >
            <div className="p-2 bg-white rounded-lg text-[#0b0f19] group-hover:rotate-12 transition-transform">
              <Terminal size={20} />
            </div>
            <span className="font-['Outfit']">PRATIK<span className="text-white group-hover:animate-pulse">.</span></span>
          </a>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className={`relative px-1 py-2 text-xs font-black uppercase tracking-widest transition-all duration-300 group ${isActive(item.href) ? "text-white" : "text-gray-400 hover:text-white"
                  }`}
              >
                {item.name}
                <span className={`absolute bottom-0 left-0 h-0.5 bg-white transition-all duration-500 ${isActive(item.href) ? "w-full" : "w-0 group-hover:w-full"
                  }`} />
              </a>
            ))}
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setIsOpen((prev) => !prev)}
            className="md:hidden p-3 rounded-2xl bg-white/5 hover:bg-white/10 text-white transition-all duration-300 focus:outline-none border border-white/10"
            aria-label="Toggle menu"
          >
            {isOpen ? <X className="h-6 w-6 text-white" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 bg-[#0b0f19]/98 backdrop-blur-3xl border-b border-white/10 ${isOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
          }`}
      >
        <div className="px-4 pt-4 pb-10 space-y-2">
          {navItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              onClick={() => setIsOpen(false)}
              className={`block px-8 py-5 rounded-[2rem] text-sm font-black uppercase tracking-widest transition-all duration-300 ${isActive(item.href)
                ? "bg-white/10 border-l-4 border-white text-white shadow-xl shadow-white/5"
                : "text-gray-400 hover:bg-white/5 hover:text-white border-l-4 border-transparent"
                }`}
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Layout;
